<template>
  <div class="roleManagementList">
    <div class="filters">
      <el-form :inline="true">
        <!-- 权限说明的折叠板 -->
        <el-collapse v-model="collapse" prop="collapse"> 
          <el-collapse-item :title="$t('lang.lab_privilegeDescription')" class="descrip">
            <div><span class="quote">{{$t('lang.lab_code')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionEncoding')}}</div>
            <div><span class="quote">{{$t('lang.lab_codeName')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionDisplayName')}}</div>
            <div><span class="quote">{{$t('lang.lab_cellRights')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_dividedInto')}}<span class="classical">{{$t('lang.lab_allDistricts')}}</span>{{$t('lang.lab_and')}}<span class="classical">{{$t('lang.lab_someDistricts')}}</span>{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_allDistricts')}}</span>{{$t('lang.lab_permissUsedCommunityLocated')}}{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_someDistricts')}}</span>{{$t('lang.lab_onlyAuthorizedUsePermissions')}}</div>
            <div><span class="quote">{{$t('lang.lab_operationAuthority')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_dividedInto')}}<span class="classical">{{$t('lang.lab_operationAuthority')}}</span>{{$t('lang.lab_and')}}<span class="classical">{{$t('lang.lab_AdministratorRights')}}</span>{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_developerPermissions')}}</span>{{$t('lang.lab_onlyDevelopersPermission')}}{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_AdministratorRights')}}</span>{{$t('lang.lab_permissionOrdinaryAdministrators')}}{{$t('lang.lab_period')}}
                 <span class="classical">{{$t('lang.lab_developerPermissions')}}</span>{{$t('lang.lab_contain')}}<span class="classical">{{$t('lang.lab_AdministratorRights')}}</span></div>
            <div><span class="quote">{{$t('lang.lab_category')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionsAre')}}<span class="classical">{{$t('lang.lab_radioSelectionType')}}</span>{{$t('lang.lab_suchAsGender')}}{{$t('lang.lab_asWelllAs')}}
                 <span class="classical">{{$t('lang.lab_multipleSelectionType')}}</span>{{$t('lang.lab_suchAsIndividualPermissions')}}</div>
            <div><span class="quote">{{$t('lang.lab_status')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_whetherAvailable')}}</div>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input class="searchInput" v-model="roleName" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <!-- 添加按钮 -->
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addRole')}}</el-button>
      <!-- 数据列表 -->
      <el-table
        :data="tableData"
        class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="this.roleManagementListCheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <!-- 角色名称 -->
        <el-table-column prop="roleName" :label="$t('lang.lbl_roleManagementList_roleName')"></el-table-column>
        <!-- 管理职务权限 -->
        <el-table-column prop="jobList" :label="$t('lang.lbl_roleManagementList_jobList')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.jobShows&&scope.row.jobShows.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span v-for="(i,index) in scope.row.jobs" :key="index">
                  {{ i }};
                  <br />
                  <br />
                </span>
              </div>
              <div>
                {{ scope.row.jobShows.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.jobShows.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div slot="content">
                <span v-for="(i,index) in scope.row.jobs" :key="index">
                  {{ i }};
                  <br />
                  <br />
                </span>
              </div>
              <div>{{ scope.row.jobShows | valueIsNull }}</div>
            </el-tooltip>
          </template>          
        </el-table-column>
        <!-- 管理职责权限 -->
        <el-table-column prop="authorityList" :label="$t('lang.lbl_roleManagementList_authorityList')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.authorityShows&&scope.row.authorityShows.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span v-for="(i,index) in scope.row.authoritys" :key="index">
                  {{ i }};
                  <br />
                  <br />
                </span>
              </div>
              <div>
                {{ scope.row.authorityShows.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.authorityShows.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div slot="content">
                <span v-for="(i,index) in scope.row.authoritys" :key="index">
                  {{ i }};
                  <br />
                  <br />
                </span>
              </div>
              <div>{{ scope.row.authorityShows | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 管理菜单权限 -->
        <el-table-column prop="munuList" :label="$t('lang.lbl_roleManagementList_munuList')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.munuShows&&scope.row.munuShows.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span v-for="(i,index) in scope.row.munus" :key="index">
                  {{ i }};
                  <br />
                  <br />
                </span>
              </div>
              <div>
                {{ scope.row.munuShows.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.munuShows.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div slot="content">
                <span v-for="(i,index) in scope.row.munus" :key="index">
                  {{ i }};
                  <br />
                  <br />
                </span>
              </div>
              <div>{{ scope.row.munuShows | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          prop="operation"
          :label="$t('lang.lab_operation')"
          fixed="right"
          :width="require('@/config/enum').opr_width3"
        >
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button
              class="orange"
              @click="deletetable(scope.row.id)"
            >{{$t('lang.btn_delete')}}</el-button>
            <span v-if="scope.row.flag === 1">（{{$t('lang.lab_activated')}}）</span>
            <span v-if="scope.row.flag === 0">（{{$t('lang.lab_notActivated')}}）</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页面 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:roleManagementList
 *@Description:角色管理
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-26
 */
export default {
  data() {
    return {
      roleName: '', // 角色名称模糊查询
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      collapse: [], // 权限说明的折叠
      multipleSelection: [], // 多选框
      roleManagementListCheckbox: require('@/config/enum')
        .roleManagementListCheckbox // 是否隐藏复选框
    }
  },
  created() {
    // #8449 add
    setTimeout(() => {
      window.localStorage.setItem('roleManagementForm', '')
      window.localStorage.setItem('roleManagementSaveData', '')
      window.localStorage.setItem('roleManagement_munuList', '')
      window.localStorage.setItem('roleManagement_munuSaveData', '')
      window.localStorage.setItem('roleManagement_jobList', '')
      window.localStorage.setItem('roleManagement_jobSaveData', '')
      window.localStorage.setItem('roleManagement_authorityList', '')
      window.localStorage.setItem('roleManagement_authoritySaveData', '')
    }, 200)
    // 初始化
    this.getTablelist()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 角色管理
    getTablelist() {
      let loading = this.$loading()
      this.$get(
        `/getRoleList?name=${this.roleName}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
            // 获取管理职务权限
            for (let i = 0; i < this.tableData.length; i++) {
              this.tableData[i].jobs = []
              for (let j = 0; j < this.tableData[i].jobList.length; j++) {
                if (this.tableData[i].jobList[j].jobName) {
                  this.tableData[i].jobs.push(
                    this.tableData[i].jobList[j].jobName
                  )
                }
              }
            }
            for (let k = 0; k < this.tableData.length; k++) {
              if (this.tableData[k].jobs) {
                this.tableData[k].jobShows = this.tableData[k].jobs.toString()
              }
            }
            // 获取管理职责权限
            for (let i = 0; i < this.tableData.length; i++) {
              this.tableData[i].authoritys = []
              for (let j = 0; j < this.tableData[i].authorityList.length; j++) {
                if (this.tableData[i].authorityList[j].authorityName) {
                  this.tableData[i].authoritys.push(
                    this.tableData[i].authorityList[j].authorityName
                  )
                }
              }
            }
            for (let k = 0; k < this.tableData.length; k++) {
              if (this.tableData[k].authoritys) {
                this.tableData[k].authorityShows = this.tableData[k].authoritys.toString()
              }
            }
            // 管理菜单权限
            for (let i = 0; i < this.tableData.length; i++) {
              this.tableData[i].munus = []
              for (let j = 0; j < this.tableData[i].munuList.length; j++) {
                if (this.tableData[i].munuList[j].munuName) {
                  this.tableData[i].munus.push(
                    this.tableData[i].munuList[j].munuName
                  )
                }
              }
            }
            for (let k = 0; k < this.tableData.length; k++) {
              if (this.tableData[k].munus) {
                this.tableData[k].munuShows = this.tableData[k].munus.toString()
              }
            }
          } 
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    // 修改
    edit(id) {
      this.$router.push({ name: 'editRoleManagement',
      query: { 
        id: id, 
        flag: true } })
    },
    // 添加
    add() {
      this.$router.push({ name: 'addRoleManagement', query: { flag: false } })
    },
    // 删除
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t(
          'lang.lab_isdeleteRoleRecommendedPermissionsAvoidDataLoss'
        ),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.$delete(`delRoleById/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.pageNo = 1
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    }
  }
}
</script>

<style lang="scss">
.roleManagementList {
  .el-collapse-item__header {
    font-size: 16px;
    padding-left: 0%;
    margin-left: 0px;
    border-bottom: 0px;
  }
  .el-collapse {
    border-top: 0px;
  }
  .el-collapse-item__content {
    font-size: 16px;
  }
  .el-collapse-item__wrap {
    will-change: height;
    // background-color: #FFF;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-bottom: 0px solid #ebeef5;
  }
  .quote {
    color: steelblue;
  }
  .classical {
    color: #419641;
  }
}
</style>
